import { IconProps } from "../../../types/style";

const SettingsIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 15.0001C13.6569 15.0001 15 13.6569 15 12.0001C15 10.3432 13.6569 9.00008 12 9.00008C10.3431 9.00008 9 10.3432 9 12.0001C9 13.6569 10.3431 15.0001 12 15.0001Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 12.8801V11.1201C2 10.0801 2.85 9.22007 3.9 9.22007C5.71 9.22007 6.45 7.94007 5.54 6.37007C5.02 5.47007 5.33 4.30007 6.24 3.78007L7.97 2.79007C8.76 2.32007 9.78 2.60007 10.25 3.39007L10.36 3.58007C11.26 5.15007 12.74 5.15007 13.65 3.58007L13.76 3.39007C14.23 2.60007 15.25 2.32007 16.04 2.79007L17.77 3.78007C18.68 4.30007 18.99 5.47007 18.47 6.37007C17.56 7.94007 18.3 9.22007 20.11 9.22007C21.15 9.22007 22.01 10.0701 22.01 11.1201V12.8801C22.01 13.9201 21.16 14.7801 20.11 14.7801C18.3 14.7801 17.56 16.0601 18.47 17.6301C18.99 18.5401 18.68 19.7001 17.77 20.2201L16.04 21.2101C15.25 21.6801 14.23 21.4001 13.76 20.6101L13.65 20.4201C12.75 18.8501 11.27 18.8501 10.36 20.4201L10.25 20.6101C9.78 21.4001 8.76 21.6801 7.97 21.2101L6.24 20.2201C5.33 19.7001 5.02 18.5301 5.54 17.6301C6.45 16.0601 5.71 14.7801 3.9 14.7801C2.85 14.7801 2 13.9201 2 12.8801Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default SettingsIcon;
